import React from 'react';
import clsx from 'clsx';
import { SETTINGS_PANEL_BODY, SETTINGS_HEADER, SETTINGS_HEADER_DESC, SETTINGS_HEADER_TITLE } from '../../utils/settingsUi';

export default function SettingsPanel({ title, description, icon: Icon, children, className }) {
  return (
    <div className={clsx(SETTINGS_PANEL_BODY, className)}>
      {(title || description) && (
        <header className={clsx(SETTINGS_HEADER, 'mb-8')}>
          <div className="flex items-start gap-3">
            {Icon && (
              <div className="mt-0.5 flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-forma-500/10 text-forma-700 dark:bg-forma-500/15 dark:text-forma-300">
                <Icon className="h-5 w-5" />
              </div>
            )}
            <div className="min-w-0">
              {title && <h2 className={SETTINGS_HEADER_TITLE}>{title}</h2>}
              {description && <p className={SETTINGS_HEADER_DESC}>{description}</p>}
            </div>
          </div>
        </header>
      )}
      <div className="min-w-0">{children}</div>
    </div>
  );
}
